import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jobsEndpoint } from "../constants";

const Applications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("token")

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${jobsEndpoint}applications/my/`, {
          headers: {
            'Authorization': `Token ${token}`,
          }
        });
        
        // Ensure we always set an array
        const data = response.data.results || response.data;
        console.log(data)
        setApplications(Array.isArray(data.applications) ? data.applications : []);
      } catch (err) {
        setError("Failed to load applications.");
        console.error(err);
        setApplications([]); // Ensure applications is always an array
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchApplications();
    }
  }, [token]);

  const handleWithdrawApplication = async (applicationId) => {
    if (window.confirm("Are you sure you want to withdraw this application?")) {
      try {
        await axios.delete(`${jobsEndpoint}${applicationId}/application_delete/`, {
          headers: {
            'Authorization': `Token ${token}`,
          }
        });
        setApplications(prevApplications => 
          prevApplications.filter(app => app.id !== applicationId)
        );
      } catch (err) {
        console.error("Failed to withdraw application:", err);
        alert("Failed to withdraw application. Please try again.");
      }
    }
  };

  return (
    <div className="lg:p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900">My Applications</h1>
        <p className="mt-1 text-sm text-gray-600">
          View and manage your job applications.
        </p>
      </div>

      {loading && <p className="text-gray-500">Loading applications...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && !error && (
        <div className="bg-white rounded-xl border border-gray-200 mt-10">
          <div className="pt-3 px-5">
            <h3 className="text-sm font-semibold text-gray-900">All Applications</h3>
          </div>
          <div className="flex gap-3 items-end py-4 px-5 border-b border-gray-200">
            <h3 className="text-2xl text-gray-900 font-semibold">
              {applications.length}
            </h3>
          </div>

          <div>
            <div className="px-5 py-3 grid md:grid-cols-4 grid-cols-2 border-b border-gray-200">
              <div className="flex gap-3 items-center col-span-2">
                <h5 className="text-gray-500 font-semibold">Position</h5>
              </div>
              <h5 className="text-gray-500 font-semibold text-xs">Date Applied</h5>
              <h5 className="text-gray-500 font-semibold text-xs">Actions</h5>
            </div>

            {applications.length === 0 ? (
              <div className="p-8 text-center">
                <div className="text-gray-400 text-6xl mb-4">📄</div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">No applications yet</h3>
                <p className="text-gray-600">You have not applied to any jobs yet.</p>
              </div>
            ) : (
              Array.isArray(applications) && applications.map((application) => (
                <div key={application.id} className="grid md:grid-cols-4 grid-cols-2 items-center p-4 border-b border-gray-200"  onClick={() => navigate(`/candidate/my_application/`+application.id)}
>
                  <div className="flex items-center gap-3 col-span-2">
                    <div>
                      <p className="md:font-medium font-bold text-sm text-gray-900">
                        {application.job_title}
                      </p>
                      <p className="text-xs text-gray-500">
                        {application.job?.company}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="font-medium text-xs text-gray-500">
                      {new Date(application.date_updated).toLocaleDateString()}
                    </p>
                  </div>
                  <div>
                    <button
                      onClick={() => handleWithdrawApplication(application.id)}
                      className="px-3 py-1 text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg hover:bg-red-200"
                    >
                      Withdraw
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Applications;